import { RUGBY_URBA_12_MATCHES } from './matches-urba-12';
import { FUTBOL_LIBERTADORES_MATCHES } from './matches-libertadores';
import { Match, MatchesConfig } from '../../types/matches';

export const MATCHES_REGISTRY: MatchesConfig[] = [
  {
    sport: 'rugby',
    league: 'urba-top-12',
    matches: RUGBY_URBA_12_MATCHES as Match[]
  },
  {
    sport: 'futbol',
    league: 'conmebol-libertadores',
    matches: FUTBOL_LIBERTADORES_MATCHES as Match[]
  }
];
